var View = require('views/base/view');
var CourseSettingsService = require('services/course-settings-service');
var AssessmentService = require('services/assessment-service');
var ProgressService = require('services/progress-service');

var AssessmentView = View.extend({
  autoRender: true,
  autoAttach: true,
  template: require('./templates/assessment'),
  className: 'panel panel-default',
  listen: {
    addedToDOM: 'loaded'
  },
  render: function() {
    var model = {
      assessments: []
    };

    model.assessments = EF.modules.reduce(function(memo, mod) {
      if(mod.get('assessment_slug')) {
        let aps = AssessmentService.getActivityProgressForSlug(mod.get('assessment_slug'), true);
        memo.push({
          slug: mod.get('assessment_slug'),
          moduleKey: mod.get('key'),
          progress: aps.length > 0,
          passed: aps ? _.some(aps, (ap) => ap.get('passed')) : false
        });
      }
      if(mod.get('pre_assessment_slug')) {
        let aps = AssessmentService.getActivityProgressForSlug(mod.get('pre_assessment_slug'), true);
        memo.push({
          slug: mod.get('pre_assessment_slug'),
          moduleKey: mod.get('key'),
          progress: aps.length > 0,
          passed: aps ? _.some(aps, (ap) => ap.get('passed')) : false
        });
      }
      return memo;
    }, []);
    this.model = new Chaplin.Model(model);

    View.prototype.render.apply(this, arguments);
  },
  loaded: function() {
    var self = this;
    this.delegate('click', '.btn-assess.btn-danger', function(e) {
      var button = e.currentTarget;
      var slug = button.attributes['data-slug'].value;
      var moduleKey = button.attributes['data-module'].value;
      ProgressService.removeLocalActivityProgress(slug, moduleKey)
        .done(() => {
          self.render();
          EF.activityProgresses.fetch();
        });
    });
    this.delegate('click', '.btn-assess.btn-success', function(e) {
      var button = e.currentTarget;
      var moduleKey = button.attributes['data-module'].value;
      var passed = !!button.attributes['data-pass'];
      ProgressService.saveLocalActivityProgress({
        'attempt': 1,
        'enrollment_id': EF.enrollment.get('id'),
        'grade': passed ? 100 : 10,
        'passed': passed,
        'slug': button.attributes['data-slug'].value
      }, moduleKey).done(() => {
        self.render();
        EF.activityProgresses.fetch();
      });
    });
  }
});

export default AssessmentView;